module.exports = __webpack_public_path__ + "svg_80x80/swift.be40df.svg";